import { Field, Int, ObjectType } from '@nestjs/graphql'
import { BaseModelDto } from '../../base'
import { BasicUserDto } from '../basicModel.dto'

@ObjectType()
export class UserStatusDto extends BaseModelDto {
  @Field(t => BasicUserDto, { nullable: true })
  adminUser?: BasicUserDto

  @Field(t => Int)
  adminUserId!: number

  @Field(t => Int)
  type!: number

  @Field()
  active!: boolean

  @Field()
  isRestriction!: boolean

  @Field({ nullable: true })
  additionalInformation?: string

  @Field({ nullable: true })
  expiryDate?: Date

  @Field(t => Int, { nullable: true })
  ineligibleReason?: number
}
